var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.42 31.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d,.e{fill:none;}.f{fill:#ffaa50;}.e{stroke:#841a0c;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.32px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M15.71,29.71c7.73,0,14-6.27,14-14S23.44,1.71,15.71,1.71,1.71,7.98,1.71,15.71s6.27,14,14,14"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 24.91,
    y1: 24.31,
    x2: 24.91,
    y2: 19.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 22.74,
    y1: 22.13,
    x2: 27.08,
    y2: 22.13
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M8.91,22.66c0-3.84,3.11-6.95,6.95-6.95,1.44,0,2.78,.44,3.88,1.19"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 15.59,
    cy: 11.46,
    r: 4.11
  })), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 24.91,
    cy: 22.13,
    r: 4.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 31.42,
    height: 31.42
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPeople);
export default __webpack_public_path__ + "static/media/add_people.6e7f60001fdf1e455a7bf02ba122020b.svg";
export { ForwardRef as ReactComponent };